// Extends from
import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

// `as const` keeps the values literal; create() freezes the array.
const notificationTransportValues = [
  { value: 'mandrill', label: 'Email', transport: 'email' },
  { value: 'modica', label: 'Text Message', transport: 'text' },
  { value: 'modica:au', label: 'Text Message', transport: 'text' },
  { value: 'fcm', label: 'Push Notification', transport: 'mobilePush' },
  { value: 'gaurun', label: 'Push Notification', transport: 'mobilePush' },
  { value: 'gorush', label: 'Push Notification', transport: 'mobilePush' },
  { value: 'unspecified', label: 'None', transport: 'none' },
] as const;

export default BaseEnum.create({
  values: notificationTransportValues,

  pushTransports: Object.freeze(
    new Set(
      notificationTransportValues
        .filter((notification) => notification.transport === 'mobilePush')
        .map((notification) => notification.value),
    ),
  ),

  emailTransports: Object.freeze(
    new Set(
      notificationTransportValues
        .filter((notification) => notification.transport === 'email')
        .map((notification) => notification.value),
    ),
  ),
});
